"use client";
import React, { useEffect, useRef,useState } from 'react';
import styled from 'styled-components';
import * as CTA from '../../util/CTA';
import * as colors from '../../util/colors';
import { important, rgba } from 'polished';
import { DefinitionBlock, Footnote, Heading, NotationBlock, Text } from '../../util/typography';
import { StaticImage } from 'gatsby-plugin-image';
import merckLogo from "../../assets/merck-logo-green.svg";
import QlexLogo from "../../assets/keytruda-qlex-logo.svg";
import { closeBlueberry, closeWhite } from '../../util/icons';
import { NAVIGATION_BREAKPOINT, NAVIGATION_BREAKPOINT_UNITLESS } from '../../constants/layout';
import { useDispatch, useSelector } from 'react-redux';
import { allowScrolling, hideJcode, preventScrolling, showJcode } from '../../store/actions';

const ModalOverlay = styled.div`
position: fixed;
height: 100%;
width: 100%;
z-index: 42;
top: 0;
left: 0;
right: 0;
bottom: 0;
opacity: 0;
animation: fade-in 0.3s 0.2s forwards;

&.bg {
    background-color: ${rgba(colors.ink, 0.8)};
}

@keyframes fade-in {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}
`;

const ModalWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 108px;
    padding-bottom: ${({ ssiHeight, siPreview }) => `${ ssiHeight +( siPreview ? 40 : 20)}px + env(safe-area-inset-bottom)`};

    min-height: 100vh;
    box-sizing: border-box;

    @media (max-width: ${NAVIGATION_BREAKPOINT}) {
        margin-inline: 20px;
        padding-top: 35px;
        padding-bottom: 155px + env(safe-area-inset-bottom);
    }
`;

const ModalContainer = styled.div`
    position: relative;
    max-width: 816px;
    width: 100%;

    background: linear-gradient(106deg, #4A0075 1.28%, #5A008F 19.07%, #6A00A8 30.62%, #7C02BB 54.58%, #8215BA 71.7%);
    padding: 8px;
    border-radius: 8px;
    overflow: hidden;
`;

const MainContainer = styled.div`
    // max-height: ${({ ssiHeight, siPreview }) => `calc(100vh - ${(siPreview ? 180  : 140) + ssiHeight}px)`};
    max-height: ${({ssiHeight}) => `calc(100vh - ${ssiHeight + 123 + 72}px)`};

    padding: 0 40px;
    padding-top: 0;
    background: ${colors.white};
    border-radius: 6px;
    overflow-y: auto;
     &::-webkit-scrollbar {
        position: absolute;
        width: 5px;
        height: 75.25px;
    }
    &::-webkit-scrollbar-thumb {
        border-radius: 8px;
        background:#BEBEBE;   
    }
        
    @media (max-width: ${NAVIGATION_BREAKPOINT}){
        max-height: ${({ ssiHeight }) => `calc(100vh - ${ssiHeight + 110}px)`};
        max-height: ${({ ssiHeight }) => `calc(100svh - ${ssiHeight + 110}px)`};

       padding: 0 10px 0 20px;
        // max-height: ${({ ssiHeight, height }) => `calc(100vh - ${height + 100}px)`};
       
        }
`;

const MainContainerWrapper = styled.div`
    background: ${colors.white};
    padding: 40px 0 32px;
    padding-right: 6px;

     &::before {
        content: '';
        display: block;
        width: calc(100% - 40px);
        height: 32px;
        z-index: 1;
        top: 47px;
        left: 9px;
        position: absolute;
        background: linear-gradient(360deg, rgba(255, 255, 255, 0.00) 0%, #FFF 100%);
        opacity: 0;
        transition: opacity 0.3s linear;
        pointer-events: none;
    }

     &::after{
        content: '';
        display: block;
        width: calc(100% - 40px);
        // height: 70px;
        height: 32px;
        bottom:0;
        z-index: 1;
        left: 9px;
        bottom: 39px;
        position: absolute;
        transform: translateY(0);
        background: linear-gradient(180deg, rgba(255, 255, 255, 0.00) 0%, #FFF 74.04%);
        opacity: 0;
        transition: opacity 0.1s linear;
        pointer-events: none;
    }


   &.fade-top {
       &::before{
        opacity: 1;
       }
    }
    
    &.fade-bottom {
       &::after{
        opacity: 1;
       }
    }

    @media (max-width: ${NAVIGATION_BREAKPOINT}){
         padding: 40px 6px 20px 0;
        &::before{
            width: calc(100% - 48px);
            height: 30px;
            left: 20px;
            }

        &::after {
            transform: translateY(0);
            width: calc(100% - 48px);
            height: 30px;
            left: 20px;
            bottom: 25px;
        }
    }
`

const CloseButton = styled.button`
    position: absolute;
    right: 16px;
    top: 16px;
    flex: none;
    width: 32px;
    height: 32px;
    cursor: pointer;
    z-index: 2;

    /* Any value greater than a single side */
    border-radius: 99px;
    background-image: url(${closeBlueberry});
    background-size: 15px 15px;
    background-repeat: no-repeat;
    background-position: center center;
    border: none;
    background-color: transparent;
    color: transparent;
    padding: 0;
    margin: 0;
    transition: 0.3s background-color ease-in-out;

    @media (hover: hover) {
    &:hover {
        background-color: ${colors.blueberryDark};
        background-image: url(${closeWhite});
        }
    }

    @media (max-width: ${NAVIGATION_BREAKPOINT}){
        right: 16px;
        top: 16px;
    }
`;

const LogoContainer = styled.div`
    height: 64px;
    width: 298px;

    margin-bottom: 20px;

    img {
        width: 100%;
        height: 100%;
    }
    @media (max-width: ${NAVIGATION_BREAKPOINT}){
        width: 224px;
        height: 48px;
        margin-bottom: 10px;
    }
    @media (max-width: 321px){
        width: 220px;
    }
`;

const JcodeHeading = styled(Heading.H3)`
font-weight: 600;
`;
const Subheading = styled(Heading.H4)`
margin: 10px 0;
`;
const JcodeContent = styled(Text.Body)`
display: block;
margin-bottom: 20px;
line-height: 20px;
color: ${colors.ink};

@media (max-width: ${NAVIGATION_BREAKPOINT}){
    margin-bottom: 10px;
    }
`;

const BottomContainer = styled.div`
display: flex;
justify-content: space-between;
align-items: flex-end;
flex-wrap: wrap;
[class^='DefinitionBlock__DefWrapper']:first-child{
    display: block;
    width: 100%;
}
img{
    margin-top: -8px;
}

@media (max-width: ${NAVIGATION_BREAKPOINT}) {
flex-direction: column;
gap: 8px;
align-items: flex-start;
picture{
    align-self: flex-end;
}
img {
    margin-top: 0;
    margin-left: auto;
    display: block;
    margin-top: 12px;
    }
}
`;

const FooterContent = styled.div`
display:flex;
gap: 8px;
flex-direction: column;
[class^='Footnote__FootnoteWrapper']{
    margin-bottom: 0px;
}
span {
    overflow-wrap: anywhere;
    color: ${colors.ink}    
}

`;

const Jcodepop = ({launch_button_container_ref}) => {
    const dispatch = useDispatch();
    const jcode = useSelector((state) => state.JcodePopup);
    const siPreview = useSelector((state) => state.indicationDrawerPreviewOpen)
    const [ssiHeight, setSsiHeight] = useState('');
    // const [overRideScrollBlock, setOverRideScrollBlock] = useState(true);
    const el = document.querySelector('[data-design-category="isi_ref_vd"]');
    const height = Math.round(((el.getBoundingClientRect().height)*100) / 100);


    useEffect(() => {
        const handleResizeSize = () =>{
            let rect;

            if(window.innerWidth > NAVIGATION_BREAKPOINT_UNITLESS){
                rect = document.querySelector('[class^="IndicationAndSafetyDrawer__LaunchButtonContainer"]').getBoundingClientRect() || launch_button_container_ref.current.getBoundingClientRect();
                setSsiHeight(Math.round(rect.height) + 15);
            }else{
                rect = document.querySelector('[class*="IndicationAndSafetyDrawer__SafetyLaunchButton"]').getBoundingClientRect() || launch_button_container_ref.current.getBoundingClientRect();
                setSsiHeight(Math.round(rect.height));
            }
            
        }
        handleResizeSize()
        window.addEventListener("resize", handleResizeSize)

        return () => window.removeEventListener("resize", handleResizeSize)
    }, [ssiHeight]);

    // useEffect(()=>{
    //     const timer = setInterval(() => {
    //         document.body.classList.add("js--scroll-lock")
    //     }, 100);

    //     const jcodeSession = sessionStorage.getItem('jcode');  

    //     if(jcodeSession && jcodeSession === "2"){
    //         setOverRideScrollBlock(false)
    //         clearInterval(timer);
    //         document.body.classList.remove("js--scroll-lock")
    //     }
    //     if(!overRideScrollBlock){
    //         clearInterval(timer);
    //         document.body.classList.remove("js--scroll-lock")
    //     }
    // },[overRideScrollBlock])
    

    useEffect(() => {
        const interval = setInterval(() => {
            const popup = document.querySelector(".onetrust-pc-dark-filter");
            const overlay = document.querySelector('#jcode-overlay');
            const hcpacknowledgement = sessionStorage.getItem('mrk-hcp--acknowledged-hcp') === '1';
            

            const jcodeSession = sessionStorage.getItem('jcode');  
            if(jcodeSession && jcodeSession === '2'){
                dispatch(hideJcode());
            }
            else if(!jcodeSession || jcodeSession !== '2'){
                dispatch(showJcode());
                dispatch(preventScrolling());
            }

            if (popup && window.getComputedStyle(popup).display === "none" && jcodeSession !== '2' && overlay && hcpacknowledgement) {   
                overlay.classList.add('bg');           
                clearInterval(interval);
                dispatch(preventScrolling());
            }
        }, 300);

        return () => clearInterval(interval);
    }, []);
    

    useEffect(() => {
        
        const interval = setInterval(()=>{
            const popup = document.getElementById("jcode-popup"); 

            if(popup){
                clearInterval(interval);
                dispatch(preventScrolling());
                const popupParent = popup.parentElement; 

                popupParent.classList.remove("fade-top");
                const handleResize = () => {
                    if (popup.scrollTop + popup.clientHeight >= popup.scrollHeight - 10) {
                     popupParent.classList.remove("fade-bottom");
                    } else {
                     popupParent.classList.add("fade-bottom"); 
                    }
                };

                handleResize();

                popup.addEventListener("scroll", handleScroll);
                window.addEventListener("resize", handleResize);

                return () => {
                    popup.removeEventListener("scroll", handleScroll);
                    window.removeEventListener("resize", handleResize);
                };               
            }
        }, 200)
        return ()=>clearInterval(interval);
    },[])

    useEffect(()=>{
        const scrollBlocker = setInterval(()=>{
             const popup = document.getElementById("jcode-popup");

             if(popup){
                 document.body.classList.add("js--scroll-lock")
             }else{
                const jcodeSession = sessionStorage.getItem('jcode');
                if(jcodeSession && jcodeSession === "2"){
                    document.body.classList.remove("js--scroll-lock")
                    clearInterval(scrollBlocker);
                }
             }

        },100)
    },[])


    useEffect(() => {
        const handleEsc = (event) => {
            if (event.key === "Escape") {
            closePopup();
            }
        };
        window.addEventListener("keydown", handleEsc);
        return () => {
          window.removeEventListener("keydown", handleEsc);
        };
    }, []);

    function handleScroll(event) {   
        const popup = event.target;
        const popupParent = popup.parentElement;
        const scrollBottom = popup.scrollHeight - popup.scrollTop - popup.clientHeight;
        const scrollTop = popup.scrollTop;
        popupParent.classList.toggle("fade-top", scrollTop > 0);
        popupParent.classList.toggle("fade-bottom", scrollBottom > 1);
    }

    const closePopup = () => {
        sessionStorage.setItem("jcode", 2);
        dispatch(hideJcode());
        dispatch(allowScrolling());
        // setOverRideScrollBlock(false)
    }    
    
    return(
    <>
       {jcode && <ModalOverlay id='jcode-overlay'>
            <ModalWrapper ssiHeight={ssiHeight} siPreview={siPreview} >
                <ModalContainer>
                    <CloseButton onClick={()=>closePopup()} />
                        <MainContainerWrapper  className='fade-bottom'>
                        <MainContainer id='jcode-popup' ssiHeight={ssiHeight} height={height} siPreview ={siPreview}>
                            <LogoContainer>
                                <picture>
                                    <img src={QlexLogo} alt='KEYTRUDA QLEX™ (pembrolizumab and berahyaluronidase alfa-pmph) Logo'  />
                                </picture>
                            </LogoContainer>
                            <JcodeHeading>Effective April 1, 2026, KEYTRUDA QLEX has a permanent HCPCS code:&#8288;&nbsp;&#8288;J9277<sup>1</sup></JcodeHeading>
                            <Subheading>To ensure accurate billing and reimbursement, update your systems with the latest HCPCS data for J9277<sup>1</sup></Subheading>
                            <JcodeContent>You are solely responsible for determining the appropriate codes and for any action you take in billing. The information provided here is not intended to be definitive or exhaustive and is not intended to replace the guidance of a qualified professional advisor. Merck and its agents make no warranties or guarantees, express or implied, concerning the accuracy or appropriateness of this information for your particular use given the frequent changes in public and private payer billing. The use of this information does not guarantee payment or that any payment received will cover your costs.</JcodeContent>
                            <FooterContent>
                                <Text.Footnote>Reference</Text.Footnote>
                                <Footnote
                                    label= '1.'
                                    text= 'Healthcare Common Procedure Coding System (HCPCS) application summaries and coding determinations: fourth quarter, 2025 HCPCS coding cycle. Centers for Medicare & Medicaid Services. Updated January 20, 2026. Accessed January 21, 2026. https://www.cms.gov/files/document/2025-hcpcs-application-summary-quarter-4-2025-drugs-biologicals.pdf' 
                                />                   
                                    
                                <BottomContainer>
                                    <DefinitionBlock
                                    className="full-width"
                                    text='HCPS = Healthcare Common Procedure Coding System.'
                                />
                                    <DefinitionBlock
                                    text='US-KEY-10523 03/26'
                                />
                                    <picture>
                                        <img src={merckLogo} alt=''  />
                                    </picture>
                                </BottomContainer>
                            </FooterContent>

                        </MainContainer>  
                        </MainContainerWrapper>              
                </ModalContainer>
            </ModalWrapper>
        </ModalOverlay>}
    </>
 )
}

export default Jcodepop;